import { ZfBox } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useUserDetails } from './api';
import { AppRoutes } from './AppRoutes';
import { ContentAdminToolbar, UserToolbar } from './components/navigation';

const appToolbarHeightMap: Record<'CONTENT' | 'RM', string> = {
    CONTENT: '110px',
    RM: '124px',
};

export const App: FunctionComponent = () => {
    const { data: user } = useUserDetails();

    const isContentUserRole = useMemo(() => user?.currentRole === 'CONTENT', [user?.currentRole]);

    return (
        <ZfBox className="app" style={{ display: 'flex', flexDirection: 'column', position: 'relative', overflowX: 'hidden' }}>
            {isContentUserRole ? <ContentAdminToolbar /> : <UserToolbar />}
            <div className="app-root" id="root-box" style={{ marginTop: appToolbarHeightMap[isContentUserRole ? 'CONTENT' : 'RM'] }}>
                <AppRoutes />
            </div>
        </ZfBox>
    );
};
